function nunjucks_global_topic_icons()
{
    this.name = 'topic_icons';
    this.value = {
        "Árak": "arak",
        "Belkereskedelem": "belker",
        "Egészségügy, baleset": "egugy",
        "Energiagazdálkodás": "energia",
        "Építőipar": "epitoip",
        "Gazdasági és nonprofit szervezetek, beruházások": "nonprofit",
        "Igazságszolgáltatás": "igazsag",
        "Információ, kommunikáció": "infokomm",
        "Ipar": "ipar",
        "Jövedelmi viszonyok, életkörülmények": "jovvisz",
        "Környezet": "korny",
        "Kultúra, sport": "kultura",
        "Kutatás-fejlesztés, innováció": "kpf",
        "Külkereskedelem": "kulker",
        "Lakás, kommunális ellátás": "lakas",
        "Mezőgazdaság": "mezo",
        "Munkaerőpiac": "munka",
        "Nemzeti számlák, GDP": "gdp",
        "Népesség, népmozgalom": "nepmozg",
        "Oktatás": "oktatas",
        "Pénzügyek": "penzugy",
        "Szállítás, közlekedés": "szallitas",
        "Szociális védelem": "szocv",
        "Turizmus, vendéglátás": "turizmus",
        "Területi statisztika": "terstat",
        "Nemzetközi statisztika": "nemzetkozi",
        
        // egyéb témakörök ..
        
        "Nemzetközi adatok": "nemzetkozi",
        "Területi adatok": "terstat",
        "Egyéb adatok": "egyeb",
        
        "Folyóiratok": "egyeb",
        "Mezőgazdasági termelői árak": "mezo",
        
        "Módszertani kiadványok, nómenklatúrák": "egyeb",
        "Összefoglaló kiadványok": "osszefog",
        "Területi összefoglaló kiadványok": "terstat",
        "Társadalomstatisztikai összefoglaló kiadványok": "nepmozg",
        "Gazdaságstatisztikai összefoglaló kiadványok": "mezo",
        
        // angol
        
        "Prices": "arak",
        "Internal trade": "belker",
        "Health care, accidents": "egugy",
        "Energy": "energia",
        "Construction": "epitoip",
        "Business units and nonprofit organisations, investments": "nonprofit",
        "Justice": "igazsag",
        "Information, communication": "infokomm",
        "Industry": "ipar",
        "Income, living conditions": "jovvisz",
        "Environment": "korny",
        "Culture, sport": "kultura",
        "Research, development, innovation": "kpf",
        "External trade": "kulker",
        "Dwellings, public utilities": "lakas",
        "Agriculture": "mezo",
        "Labour market": "munka",
        "National accounts, GDP": "gdp",
        "Population, vital statistics": "nepmozg",
        "Education": "oktatas",
        "Finance": "penzugy",
        "Transport": "szallitas",
        "Social protection": "szocv",
        "Tourism, catering": "turizmus",
        "Regional statistics": "terstat",
        "International statistics": "nemzetkozi",
        
        // egyéb alternatívák
        
        "Regional data": "terstat",
        "Other statistics": "egyeb",
        "Other data": "egyeb",
        
        "Price statistics": "arak",
        "Financial statistics": "penzugy",
        "External trade statistics": "kulker",
        "Research and development, innovation statistics": "kpf",
        "Research, development": "kpf",
        "Agricultural producer prices": "mezo",
        "Construction statistics": "epitoip",
        "Housing and public utilities": "lakas",
        "Population and vital events": "nepmozg",
        "Income and living conditions": "jovvisz",
        "Business units and nonprofit organisatons, investment": "nonprofit",
        
        "Comprehensive publications": "osszefog",
        "Comprehensive regional publications": "terstat"
        
    };
}
